<template>
  <div class="bg-light pb-4">
    <nav-title :color="true" :title="'Home Challenge'" />
    <data-description>
      <div class="bg-main text-light">{{ description }}</div>
    </data-description>
    <box-button
      v-for="item in contentBox"
      :key="item.id"
      :description="item.description"
      :buttonText="item.buttonText"
      :buttonColor="item.buttonColor"
      :router="item.router"
    />
  </div>
</template>
<script>
import navTitle from "@/components/general/navTitle.vue";
import dataDescription from "@/components/general/dataDescription.vue";
import boxButton from "@/components/general/boxButton.vue";

export default {
  components: {
    navTitle,
    dataDescription,
    boxButton
  },
  data() {
    return {
      description: "Learn and manage your child’s challenge",
      contentBox: [
        {
          id: 0,
          description: "Learn more about using and setting up home challenge",
          buttonText: "Learn",
          buttonColor: "aside01",
          router: "challenge-description"
        },
        {
          id: 1,
          description: "Create or edit child's home challenge",
          buttonText: "Create",
          buttonColor: "aside02",
          router: "challenge-select-child?next=challenge-create"
        },
        {
          id: 2,
          description: "Check child’s home challenge",
          buttonText: "Check",
          buttonColor: "aside03",
          router: "challenge-select-child?next=challenge-parent-approve"
        },
        {
          id: 3,
          description: "Show child's progress",
          buttonText: "Show",
          buttonColor: "aside05",
          router: "/progress?showChild=true"
        }
      ]
    };
  }
};
</script>
